import { useSelector } from 'react-redux'

import { ENTITLEMENT_ACCESS_CONFIG_DEFAULTS } from '@webapp/core/services/Entitlement'
import {
  makeSelectEntitlementAccessConfig,
  makeSelectIsAppReady,
} from '@webapp/core/stores/global'

export const useEntitlement = () => {
  const isAppReady = useSelector(makeSelectIsAppReady())
  const entitlement = useSelector(makeSelectEntitlementAccessConfig())

  if (!isAppReady) {
    return { ...ENTITLEMENT_ACCESS_CONFIG_DEFAULTS }
  }

  return entitlement
}
